import { ColDef } from 'ag-grid-community';

import ExtraItemTagCellRenderer from 'app/components/AdvancedGrid/CellRenderers/ExtraItemTagCellRenderer/ExtraItemTagCellRenderer';
import IconButtonCellRenderer from 'app/components/AdvancedGrid/CellRenderers/IconButtonCellRenderer/IconButtonCellRenderer';
import { RuleCellRenderer } from 'app/components/AdvancedGrid/CellRenderers/RuleCellRenderer/RuleCellRenderer';
import TerritoryGroupRenderer from 'app/components/AdvancedGrid/CellRenderers/TerritoryGroupRenderer/TerritoryGroupRenderer';
import { TextRenderer } from 'app/components/AdvancedGrid/CellRenderers/TextRenderer/TextRenderer';
import { formatDataForExtraTagCellRenderer } from 'app/components/AdvancedGrid/GridHelper';

import { MEASURES_GRID_COLUMN_WIDTH_ICON_SMALL } from 'app/global/variables';

import { IconButtonCellRendererType, UserRoleType, GridFields, TerritoryGridRow } from 'app/models';

import { formatMessage } from 'utils/messages/utils';

interface TerritoryColumnDefParams {
  activityDrillIn: (rowData: TerritoryGridRow) => void;
  onEditTerritory: (rowData: TerritoryGridRow) => void;
  userRole: UserRoleType;
}

const buildTerritoryColumnDef = (territoryColumnDefParams: TerritoryColumnDefParams): ColDef[] => {
  const { activityDrillIn, onEditTerritory, userRole } = territoryColumnDefParams;

  const getAdminMenuColumns: () => ColDef[] = () => {
    return [
      {
        width: MEASURES_GRID_COLUMN_WIDTH_ICON_SMALL,
        pinned: 'right',
        cellRendererSelector: (params) => {
          if (params?.node?.rowPinned) {
            return {
              component: '',
              params
            };
          } else {
            return {
              component: IconButtonCellRenderer,
              params: {
                onEditCellClick: onEditTerritory,
                iconCellRendererType: IconButtonCellRendererType.EDIT_TERRITORY
              }
            };
          }
        }
      }
    ];
  };

  const columnDefs: ColDef[] = [
    {
      headerName: formatMessage('TERRITORY_ID'),
      field: GridFields.TERRITORY_ID,
      pinned: 'left',
      sortable: true,
      resizable: true,
      flex: 1,
      minWidth: 200,
      maxWidth: null,
      cellRenderer: TextRenderer,
      cellRendererParams: {
        onCellClick: activityDrillIn,
        'data-testid': 'territory-grid-terr-id-renderer'
      }
    },
    {
      headerName: formatMessage('TERRITORY_NAME'),
      field: GridFields.TERRITORY_NAME,
      pinned: 'left',
      sortable: true,
      resizable: true,
      flex: 1,
      minWidth: 200,
      maxWidth: null,
      cellRenderer: TextRenderer
    },
    {
      headerName: formatMessage('TERRITORY_GROUP'),
      field: GridFields.TERRITORY_GROUP,
      pinned: 'left',
      flex: 1,
      minWidth: 200,
      maxWidth: null,
      cellRenderer: TerritoryGroupRenderer,
      resizable: true
    },
    {
      headerName: formatMessage('SELLER'),
      field: GridFields.SELLER,
      flex: 1,
      pinned: 'left',
      minWidth: 250,
      maxWidth: null,
      cellRenderer: ExtraItemTagCellRenderer,
      cellRendererParams: (params) => {
        const formatSellerName = (seller) => seller && `${seller.firstName} ${seller.lastName}`;
        return formatDataForExtraTagCellRenderer(params, GridFields.OWNERS, formatSellerName);
      }
    },
    {
      headerName: formatMessage('TERRITORY_RULE'),
      field: GridFields.TERRITORY_RULE,
      flex: 1,
      minWidth: 200,
      maxWidth: null,
      cellRenderer: RuleCellRenderer
    }
  ];
  // eslint-disable-next-line no-restricted-syntax
  if (userRole === UserRoleType.ADMIN) {
    columnDefs.push(...getAdminMenuColumns());
  }
  return columnDefs;
};

export default buildTerritoryColumnDef;
